import { HeadingProps } from './types';

export const LabelHeading = ({ name }: HeadingProps) => <span className="block text-sm font-accent">{name}</span>;
